import React, { Component } from 'react';
import { Transition } from 'react-spring';
import Gradients from './gradients';

class GradientBGTransition extends Component {
  constructor() {
    super();
    this.state = {
      index: 0,
    };
  }

  loop = i => {
    this.timerHandle = setTimeout(() => {
      if (i === 4) {
        i = 0;
      }
      this.setState(state => ({
        index: state.index === 3 ? 0 : state.index + 1,
      }));
      this.loop(i + 1);
      this.timerHandle = 0;
    }, 3500);
  };

  componentDidMount() {
    this.loop(0);
  }

  componentWillUnmount() {
    if (this.timerHandle) {
      clearTimeout(this.timerHandle);
      this.timerHandle = 0;
    }
  }

  render() {
    return (
      <Transition
        native
        items={this.state.index}
        from={{ opacity: 0 }}
        enter={{ opacity: 1 }}
        leave={{ opacity: 0 }}
        config={{ tension: 60, friction: 100 }}
      >
        {index => Gradients[index]}
      </Transition>
    );
  }
}

export default GradientBGTransition;



// WEBPACK FOOTER //
// ./src/components/gradient-bg-transition/index.js